import React, { useState, useEffect } from 'react';
import { Collapse } from '@material-ui/core';
import PropTypes from 'prop-types';

// UTILITY
import { customAnalyticsEvent } from '@/utility/analytics';

// HOOKS
import useAuth from '@/hooks/useAuth';

// COMPONENTS
import DialogLessChannels from '@/components/Dialogs/DialogLessChannels';

// HELP
import LessChannelsAlert from './LessChannelsAlert';

// STYLES
import LessChannelsNotificationStyled from './styles';

const LessChannelsNotification = ({ show }) => {
  const unique_id = useAuth(auth => auth.unique_id);
  const anonymousId = useAuth(auth => auth.anonymousId);
  const [onceShownAlert, setOnceShownAlert] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);

  function onOpenDialog() {
    setOpenDialog(true);

    customAnalyticsEvent('channels alert "learn more" button was clicked', {
      unique_id: unique_id || anonymousId,
    });
  }

  function onCloseAlert() {
    setShowAlert(false);
  }

  function onCloseDialog() {
    setOpenDialog(false);
    onCloseAlert();
  }

  useEffect(() => {
    if (!onceShownAlert && show && !showAlert) {
      setShowAlert(true);
      setOnceShownAlert(true);

      customAnalyticsEvent('channels alert was shown', {
        unique_id: unique_id || anonymousId,
      });
    }
  }, [show, showAlert, onceShownAlert]);

  return (
    <LessChannelsNotificationStyled>
      <Collapse in={showAlert}>
        <LessChannelsAlert onClose={onCloseAlert} onClick={onOpenDialog} />
      </Collapse>
      <DialogLessChannels open={openDialog} onClose={onCloseDialog} />
    </LessChannelsNotificationStyled>
  );
};

LessChannelsNotification.propTypes = {
  show: PropTypes.bool.isRequired,
};

export default React.memo(LessChannelsNotification);
